var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validate", {
    attrs: {
      tag: "div",
      name: _vm.label || _vm.name,
      rules: _vm.rules,
      vid: _vm.vid
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          return [
            _c(
              "b-field",
              {
                attrs: {
                  expanded: "expanded",
                  "label-position": "inside",
                  label: _vm.label,
                  message: errors,
                  type: { "is-danger": errors[0] }
                }
              },
              [
                !_vm.options
                  ? _c("b-input", {
                      attrs: {
                        expanded: "expanded",
                        disabled: _vm.disabled,
                        type: _vm.type,
                        "password-reveal": _vm.passwordReveal,
                        loading: _vm.loading,
                        size: _vm.small ? "is-small" : null
                      },
                      nativeOn: {
                        keydown: function($event) {
                          return _vm.$emit("keydown", $event)
                        }
                      },
                      model: {
                        value: _vm.mutatableValue,
                        callback: function($$v) {
                          _vm.mutatableValue = $$v
                        },
                        expression: "mutatableValue"
                      }
                    })
                  : _c(
                      "b-select",
                      {
                        attrs: {
                          expanded: "expanded",
                          disabled: _vm.disabled,
                          placeholder: _vm.placeholder,
                          loading: _vm.loading,
                          size: _vm.small ? "is-small" : null
                        },
                        model: {
                          value: _vm.mutatableValue,
                          callback: function($$v) {
                            _vm.mutatableValue = $$v
                          },
                          expression: "mutatableValue"
                        }
                      },
                      [
                        _vm.valueProperty && _vm.textProperty
                          ? _vm._l(_vm.options, function(option) {
                              return _c(
                                "option",
                                {
                                  domProps: { value: option[_vm.valueProperty] }
                                },
                                [_vm._v(_vm._s(option[_vm.textProperty]))]
                              )
                            })
                          : _vm.isKeyValue
                          ? [
                              _vm.reversedKeyValue
                                ? _vm._l(_vm.options, function(text, value) {
                                    return _c(
                                      "option",
                                      { domProps: { value: text } },
                                      [_vm._v(_vm._s(value))]
                                    )
                                  })
                                : _vm._l(_vm.options, function(text, value) {
                                    return _c(
                                      "option",
                                      { domProps: { value: value } },
                                      [_vm._v(_vm._s(text))]
                                    )
                                  })
                            ]
                          : _vm._l(_vm.options, function(text, value) {
                              return _c(
                                "option",
                                {
                                  domProps: {
                                    value: _vm.isObject(text) ? value : text
                                  }
                                },
                                [_vm._v(_vm._s(text))]
                              )
                            })
                      ],
                      2
                    )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }